/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InitialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { WorkflowLayoutComponent } from './layout/layout.component';
import { WorkflowBuilderComponent } from './workflow-builder/workflow-builder.component';

const routes: Routes = [
  {
    path: 'workflow-builder',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
        initialData: InitialDataResolver,
    },
    children: [
        { 
          path: 'workflows',
          component: WorkflowLayoutComponent,
          children: [
            {
              path: '',
              loadComponent: () => import('./workflows/workflows.component').then(c => c.WorkflowsComponent)
            },
            {
              path: 'templates',
              pathMatch: 'full',
              loadComponent: () => import('./templates/templates.component').then(c => c.TemplatesComponent),
            },
            {
              path: 'executions',
              pathMatch: 'full',
              loadComponent: () => import('./executions/executions.component').then(c => c.ExecutionsComponent),
            },
            {
              path: 'variables',
              pathMatch: 'full',
              loadComponent: () => import('./variables/variables.component').then(c => c.VariablesComponent),
            },
            {
              path: 'insights',
              pathMatch: 'full',
              loadComponent: () => import('./workflow-insights/workflow-insights.component').then(c => c.WorkflowInsightsComponent),
            }
          ]
        },
        {
          path: 'new',
          loadComponent: () => import('./workflow-builder/workflow-builder.component').then(c => c.WorkflowBuilderComponent),
          canDeactivate: [(component: WorkflowBuilderComponent) => !component.hasUnsavedChanges]
        },
        {
            path: 'workflows/:workflow_uid',
            loadComponent: () => import('./workflow-builder/workflow-builder.component').then(c => c.WorkflowBuilderComponent),
            canDeactivate: [(component: WorkflowBuilderComponent) => !component.hasUnsavedChanges]
        },
        { path: 'workflows', redirectTo: 'workflows' },
        { path: '', redirectTo: 'workflows', pathMatch: 'full' }
        
    ]
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
